import PropTypes from 'prop-types';
import { createContext, useContext, useReducer, useState } from 'react';

import { noop } from 'lib/utils';

const INITIAL_ACTIVE_STEP = 1;

const StepperContext = createContext({
  activeStep: INITIAL_ACTIVE_STEP,
  steps: [],
  setSteps: noop,
  changeActiveStep: noop,
});

const activeStepReducer = (activeStep, { type }) => {
  switch (type) {
    case 'reset':
      return INITIAL_ACTIVE_STEP;
    case 'next':
      return activeStep + 1;
    case 'prev':
      return activeStep !== 0 ? activeStep - 1 : 0;
    default:
      break;
  }
};

const StepperProvider = ({ steps: initialSteps = [], children }) => {
  const [activeStep, dispatchActiveStep] = useReducer(
    activeStepReducer,
    INITIAL_ACTIVE_STEP
  );
  const [steps, setSteps] = useState(initialSteps);

  return (
    <StepperContext.Provider
      value={{
        activeStep,
        steps,
        changeActiveStep: dispatchActiveStep,
        setSteps,
      }}
    >
      {children}
    </StepperContext.Provider>
  );
};

export const useStepper = () => useContext(StepperContext);

StepperProvider.propTypes = {
  children: PropTypes.node.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string),
};

export default StepperProvider;
